/** Removes data that is unsafe to disclose to Sentry from outgoing events. */
export function scrubSentryEvent<T extends object>(event: T): T {
  const unsafeEvent = event as T & {
    breadcrumbs?: unknown[]
    request?: unknown
    user?: { id?: unknown }
    spans?: Array<{ data?: Record<string, unknown> }>
  }

  delete unsafeEvent.request

  if (unsafeEvent.user?.id) unsafeEvent.user = { id: unsafeEvent.user.id }
  else delete unsafeEvent.user

  unsafeEvent.breadcrumbs = []

  for (const span of unsafeEvent.spans ?? []) {
    if (span.data) {
      for (const key of ['http.query', 'http.fragment', 'url.query', 'url.fragment']) {
        delete span.data[key]
      }
      for (const key of ['url', 'url.full']) {
        if (typeof span.data[key] === 'string') {
          span.data[key] = span.data[key].split(/[?#]/, 1)[0]
        }
      }
    }
  }

  return event
}
